import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ChartOptions, LegendOptions, TooltipItem } from 'chart.js';
import { ChartsDataSet } from 'app/shared/utils/charts-data-set';

@Component({
    selector: 'mh-chart-bar',
    templateUrl: './bar-chart.component.html',
    styleUrls: ['./bar-chart.component.scss'],
    standalone: false
})
export class BarChartComponent implements OnInit {
  COLORS = (new ChartsDataSet()).lineChartColors()

  @Input() datasets: {data: string[], label: string, tooltips: string[]}[] = [];
  @Input() labels: string[] = [];
  @Input() legendDisplay:boolean = true;
  @Input() legendPosition: 'top' | 'bottom' | 'left' | 'right' = 'bottom';

  @Output() chartClick = new EventEmitter<any>()

  options:ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        onHover: function(e:any) {
          if (e?.native?.target?.style) {
            e.native.target.style.cursor = 'pointer';
          }
        }
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (item:TooltipItem<any>) => this.datasets[item.datasetIndex].tooltips[item.dataIndex],
        }
      },
      datalabels: {
        display: false
      }
    },
    scales:{
      y: {
        ticks: {
          callback: (value:number) => `${value}%`,
        },
        min: 0,
        max: 100,
        // stepSize: 10, // Comentado temporalmente por incompatibilidad con Chart.js v4
      }
    },
    onHover: function(e:any) {
      if (e?.native?.target?.style) {
        e.native.target.style.cursor = 'default';
      }
    }
  }

  constructor() { }

  ngOnInit() {
  }

  handleClick(e:any) {
    this.chartClick.emit(e)
  }

  get legendOptions(): any{
    return {
      position: this.legendPosition,
      display: this.legendDisplay,
    }
  }
}

